import axios from "axios";
import { notification } from "antd";

import { ACTION_TYPES } from "../redux/sections/constants";

const baseUrl = process.env.REACT_APP_API_URL;
// axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`
const config = {
  headers: { Authorization: "" }
};
export const getSections = () => {
  return async (dispatch) => {
    try {
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
      const res = await axios.get(`${baseUrl}/sections`, config);
      dispatch({
        type: "getSections",
        payload: res.data.data,
      });
    } catch (error) {
      dispatch({
        type: "error",
        payload: error,
      });
    }
  };
};

export const addSection = (data, callBack, intl, forcedPosition) => {
  let backgroundColorArray = [
    "#24CF73",
    "#F4BF00",
    "#0077EE",
    "#FE3C32",
    "#936BF3",
  ];
  function getRandomNum(min = 0, max = 5) {
    return Math.floor(Math.random() * (max - min) + min);
  }
  return async (dispatch) => {
    try {
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
      dispatch({
        type: ACTION_TYPES.ADD_SECTION_REQUEST
      });
      const res = await axios.post(`${baseUrl}/sections/add`, { ...data, color: backgroundColorArray[getRandomNum()] }, config);

      const payload = { ...(res?.data?.data || {}) };

      if (typeof forcedPosition === 'number') {
        payload.position = forcedPosition;
      }

      dispatch({
        type: ACTION_TYPES.ADD_SECTION_REQUEST_SUCCESS,
        payload,
      });

      await dispatch({
        type: "success",
        payload: res,
      });
      callBack && callBack(res?.data?.data);

      notification.success({
        message: intl.formatMessage({ id: 'ADDED_SECTION_NOTIFICATION', defaultMessage: "You've just added a new section" }),
        placement: "bottomRight",
      });
    } catch (error) {
      dispatch({
        type: "error",
        payload: error,
      });
      notification.error({
        message: error?.response?.data?.message || intl.formatMessage({ id: 'SECTION_TITLE_IN_USE', defaultMessage: "Section's Title already used" }),
        placement: "bottomRight",
      });
    }
  };
};

export const deleteSection = (id, callBack, intl) => {
  return async (dispatch) => {
    try {
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
      const res = await axios.post(`${baseUrl}/sections/remove`, {
        sectionId: id
      }, config);
      dispatch({
        type: "success",
        payload: res,
      });
      dispatch({
        type: ACTION_TYPES.REMOVE_SECTION_SUCCESS,
        payload: id,
      });
      notification.success({
        message: intl.formatMessage({ id: 'DELETED_SECTION_NOTIFICATION', defaultMessage: "You've just deleted a section" }),
        placement: "bottomRight",
      });
      callBack();
    } catch (error) {
      dispatch({
        type: "error",
        payload: error,
      });
      notification.error({
        message: intl.formatMessage({ id: 'OOPS_SOMETHING_WRONG', defaultMessage: 'Oops! something went wrong' }),
        placement: "bottomRight",
      });
    }
  };
};

export const editSection = (data, callBack, intl) => {
  return async (dispatch) => {
    try {
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
      const res = await axios.put(`${baseUrl}/sections/edit`, data, config);
      await dispatch({
        type: "success",
        payload: res,
      });
      callBack();
      notification.success({
        message: intl.formatMessage({ id: 'UPDATED_SECTION_NOTIFICATION', defaultMessage: 'You just update a section' }),
        placement: "bottomRight",
      });
    } catch (error) {
      dispatch({
        type: "error",
        payload: error,
      });
      notification.error({
        message: intl.formatMessage({ id: 'SECTION_TITLE_IN_USE', defaultMessage: "Section's Title already used" }),
        placement: "bottomRight",
      });
    }
  };
};

export const isDuplicateField = (val) => {
  return {
    type: "isDuplicateField",
    payload: val,
  };
};
